import staffFetch from "./staffFetch";
import React, { useEffect, useState } from "react";

const API = "https://live-evo.com/api";

function StaffSpecialRequestsPage() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [replyText, setReplyText] = useState({});

  const loadRequests = async () => {
    try {
      setLoading(true);

      const res = await staffFetch(`${API}/staff/requests`);
      const data = await res.json();

      setRequests(data.requests || []);
    } catch (err) {
      console.log("Erreur demandes particulières:", err);
      alert("Impossible de charger les demandes particulières");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRequests();
  }, []);

  const replyRequest = async (id) => {
    const message = replyText[id];

    if (!message || !message.trim()) {
      alert("Écris une réponse avant d’envoyer");
      return;
    }

    try {
      await staffFetch(`${API}/staff/requests/${id}/reply`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          staff_reply: message.trim()
        })
      });

      alert("Réponse envoyée et demande fermée");

      setReplyText({
        ...replyText,
        [id]: ""
      });

      loadRequests();
    } catch (err) {
      console.log("Erreur réponse:", err);
      alert("Impossible d’envoyer la réponse");
    }
  };

  const closeRequest = async (id) => {
    try {
      await staffFetch(`${API}/staff/requests/${id}/status`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          status: "closed"
        })
      });

      alert("Demande fermée");

      loadRequests();
    } catch (err) {
      console.log("Erreur fermeture:", err);
      alert("Impossible de fermer la demande");
    }
  };

  const deleteRequest = async (id) => {
    const ok = window.confirm("Supprimer cette demande définitivement ?");

    if (!ok) return;

    try {
      await staffFetch(`${API}/staff/requests/${id}`, {
        method: "DELETE"
      });

      alert("Demande supprimée");

      loadRequests();
    } catch (err) {
      console.log("Erreur suppression:", err);
      alert("Impossible de supprimer la demande");
    }
  };

  return (
    <div
      style={{
        background: "#020b14",
        minHeight: "100vh",
        padding: 20,
        color: "#fff"
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <h1
          style={{
            color: "#00f2ff",
            textAlign: "center",
            marginBottom: 20
          }}
        >
          📝 Demandes particulières
        </h1>

        {loading && (
          <div style={{ textAlign: "center", color: "#00f2ff" }}>
            Chargement...
          </div>
        )}

        {!loading && requests.length === 0 && (
          <div
            style={{
              color: "#8fa6ad",
              textAlign: "center",
              marginTop: 30
            }}
          >
            Aucune demande particulière.
          </div>
        )}

        {requests.map((item) => {
          const isClosed = item.status === "closed";

          return (
            <div
              key={item.id}
              style={{
                background: "#061827",
                border: "1px solid #12344a",
                borderRadius: 12,
                padding: 14,
                marginBottom: 14
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 10,
                  flexWrap: "wrap"
                }}
              >
                <div
                  style={{
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: 15
                  }}
                >
                  {item.subject || "Demande particulière"}
                </div>

                <div
                  style={{
                    background: isClosed ? "#555" : "#00f2ff",
                    color: isClosed ? "#fff" : "#001018",
                    fontWeight: "bold",
                    fontSize: 10,
                    padding: "4px 8px",
                    borderRadius: 8
                  }}
                >
                  {isClosed ? "FERMÉE" : "OUVERTE"}
                </div>
              </div>

              <div
                style={{
                  color: "#8fa6ad",
                  fontSize: 12,
                  marginTop: 6
                }}
              >
                Email : {item.user_email}
              </div>

              <div
                style={{
                  color: "#8fa6ad",
                  fontSize: 12,
                  marginTop: 4
                }}
              >
                Type : {item.type || "general"}
              </div>

              <div
                style={{
                  color: "#fff",
                  marginTop: 12,
                  lineHeight: "20px"
                }}
              >
                {item.message}
              </div>

              {item.staff_reply && (
                <div
                  style={{
                    background: "#020b14",
                    borderRadius: 10,
                    padding: 10,
                    marginTop: 12,
                    border: "1px solid #00f2ff"
                  }}
                >
                  <div
                    style={{
                      color: "#00f2ff",
                      fontWeight: "bold",
                      marginBottom: 5,
                      fontSize: 12
                    }}
                  >
                    Réponse staff :
                  </div>

                  <div style={{ color: "#fff", fontSize: 13 }}>
                    {item.staff_reply}
                  </div>
                </div>
              )}

              {!isClosed && (
                <>
                  <textarea
                    placeholder="Réponse staff..."
                    value={replyText[item.id] || ""}
                    onChange={(e) =>
                      setReplyText({
                        ...replyText,
                        [item.id]: e.target.value
                      })
                    }
                    style={{
                      background: "#020b14",
                      border: "1px solid #1a3d52",
                      color: "#fff",
                      borderRadius: 8,
                      padding: 10,
                      marginTop: 14,
                      minHeight: 90,
                      width: "100%",
                      resize: "vertical"
                    }}
                  />

                  <button
                    onClick={() => replyRequest(item.id)}
                    style={greenBtn}
                  >
                    Répondre et fermer
                  </button>

                  <button
                    onClick={() => closeRequest(item.id)}
                    style={orangeBtn}
                  >
                    Fermer sans réponse
                  </button>
                </>
              )}

              <button
                onClick={() => deleteRequest(item.id)}
                style={redBtn}
              >
                Supprimer
              </button>
            </div>
          );
        })}

        <button
          onClick={() => {
            window.location.href = "/staff";
          }}
          style={backBtn}
        >
          ← Retour Staff
        </button>
      </div>
    </div>
  );
}

const greenBtn = {
  background: "#00aa66",
  padding: 10,
  borderRadius: 8,
  border: "none",
  color: "#fff",
  fontWeight: "bold",
  width: "100%",
  marginTop: 10,
  cursor: "pointer"
};

const orangeBtn = {
  background: "#ff9500",
  padding: 10,
  borderRadius: 8,
  border: "none",
  color: "#fff",
  fontWeight: "bold",
  width: "100%",
  marginTop: 10,
  cursor: "pointer"
};

const redBtn = {
  background: "#ff2d55",
  padding: 10,
  borderRadius: 8,
  border: "none",
  color: "#fff",
  fontWeight: "bold",
  width: "100%",
  marginTop: 10,
  cursor: "pointer"
};

const backBtn = {
  background: "#007bff",
  padding: 12,
  borderRadius: 8,
  border: "none",
  color: "#fff",
  fontWeight: "bold",
  width: "100%",
  marginTop: 20,
  cursor: "pointer"
};

export default StaffSpecialRequestsPage;
